import { isWebView } from '../utils/webviewDetector';
import i18n from '../i18n';

const isReactNativeWebView = () => {
	return window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function';
};

const sendPDFToReactNative = (base64, fileName) => {
	try {
		if (!isReactNativeWebView()) {
			return false;
		}

		const message = JSON.stringify({
			type: 'EXPORT_PDF',
			data: {
				fileName: fileName,
				base64: base64,
				mimeType: 'application/pdf'
			}
		});

		window.ReactNativeWebView.postMessage(message);
		return true;
	} catch (error) {
		return false;
	}
};

const setupPDFExportListener = () => {
	window.addEventListener('pdf-export-success', (event) => {
		if (event.detail && event.detail.fileName) {
			showExportMessage(true, event.detail.fileName);
		}
	});
};

if (typeof window !== 'undefined') {
	setupPDFExportListener();
}

const showExportMessage = (success, fileName) => {
	const existingMsg = document.getElementById('pdf-export-message');
	if (existingMsg) {
		existingMsg.remove();
	}

	const messageDiv = document.createElement('div');
	messageDiv.id = 'pdf-export-message';
	messageDiv.style.cssText = `
		position: fixed;
		top: 20px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 999999;
		background: ${success ? '#4CAF50' : '#f44336'};
		color: white;
		padding: 15px 25px;
		border-radius: 5px;
		box-shadow: 0 4px 6px rgba(0,0,0,0.1);
		font-size: 14px;
		text-align: center;
	`;

	const lang = i18n.language || 'pt-BR';
	const successMsg = lang.includes('en') ?
		`✓ PDF "${fileName}" exported successfully!` :
		lang.includes('es') ?
		`✓ PDF "${fileName}" exportado con éxito!` :
		`✓ PDF "${fileName}" exportado com sucesso!`;

	const errorMsg = lang.includes('en') ?
		`✗ Error exporting PDF.` :
		lang.includes('es') ?
		`✗ Error al exportar PDF.` :
		`✗ Erro ao exportar PDF.`;

	messageDiv.innerHTML = success ? successMsg : errorMsg;

	document.body.appendChild(messageDiv);

	setTimeout(() => {
		if (document.getElementById('pdf-export-message')) {
			document.getElementById('pdf-export-message').remove();
		}
	}, 3000);
};

export const displayPDFInViewer = (pdfBlob, fileName) => {
	try {
		const reader = new FileReader();
		reader.onloadend = function() {
			const base64data = reader.result;
			const base64Only = base64data.split(',')[1];

			if (isReactNativeWebView()) {
				const sent = sendPDFToReactNative(base64Only, fileName);
				if (!sent) {
					showExportMessage(false, fileName);
				}
			} else if (isWebView()) {
				showExportMessage(false, fileName);
			} else {
				const link = document.createElement('a');
				link.href = base64data;
				link.download = fileName;
				link.style.display = 'none';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				showExportMessage(true, fileName);
			}
		};
		reader.readAsDataURL(pdfBlob);

		return {
			success: true,
			method: isReactNativeWebView() ? 'react-native' : (isWebView() ? 'webview' : 'browser-download'),
			message: 'PDF processing'
		};

	} catch (error) {
		return {
			success: false,
			error: error.message
		};
	}
};

export const sendPDFUrlToReactNative = (pdfUrl, fileName = null) => {
	try {
		if (!isReactNativeWebView()) {
			return false;
		}

		const message = JSON.stringify({
			type: 'OPEN_PDF_URL',
			data: {
				pdfUrl: pdfUrl,
				fileName: fileName || pdfUrl.split('/').pop()
			}
		});

		window.ReactNativeWebView.postMessage(message);
		return true;
	} catch (error) {
		return false;
	}
};

export const openPDFSimple = (pdf, fileName) => {
	try {
		const pdfBlob = pdf.output('blob');
		return displayPDFInViewer(pdfBlob, fileName);
	} catch (error) {
		return {
			success: false,
			error: error.message
		};
	}
};